<template>
  <div>
    <v-list-item @click="selectBankImportFile(bankImport.id)">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-list-item-avatar :color="colour" size="42" v-on="on" style="justify-content: center">
            <span class="white--text title">{{ bankImport.successful }}</span>
          </v-list-item-avatar>
        </template>
        <span>Successful imports</span>
      </v-tooltip>
      <v-list-item-content>
        <v-list-item-title>{{ bankImport.business }}</v-list-item-title>
        <v-list-item-subtitle>{{ bankImport.file_name }}</v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action>
        <v-list-item-action-text>{{ bankImport.created_at | moment('DD/MM/YYYY HH:mm') }}</v-list-item-action-text>
        <div>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-avatar color="warning" size="24" class="mr-1" v-on="on">
                <span class="white--text body-2">{{ bankImport.duplicates }}</span>
              </v-avatar>
            </template>
            <span>Duplicates</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-avatar color="error" size="24" class="mr-1" v-on="on">
                <span class="white--text body-2">{{ bankImport.failed }}</span>
              </v-avatar>
            </template>
            <span>Failed</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-avatar color="info" size="24" v-on="on">
                <span class="white--text body-2">{{ bankImport.total_records }}</span>
              </v-avatar>
            </template>
            <span>Total records</span>
          </v-tooltip>
        </div>
      </v-list-item-action>
    </v-list-item>
    <v-divider inset></v-divider>
  </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  name: 'BankImportRow',
  props: {
    bankImport: Object
  },
  computed: {
    colour() {
      return this.bankImport.failed > 0 ? 'error' : this.bankImport.duplicates > 0 ? 'warning' : 'success';
    }
  },
  methods: mapActions(['selectBankImportFile'])
};
</script>
